import { useState } from "react";
import InputField from "components/fields/InputField";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { loginService } from "api/services/adminService";
import { toast } from "react-toastify";

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleLogin = async () => {
    const newErrors = {};
    if (!email) newErrors.email = "Email is required.";
    else if (!validateEmail(email))
      newErrors.email = "Please enter a valid email address.";

    if (!password) newErrors.password = "Password is required.";

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      return;
    }

    try {
      const response = await loginService({
        email,
        password,
      });

      const { token } = response.data;
      Cookies.set("token", token, {
        expires: 7,
        secure: true,
        sameSite: "Strict",
      });

      navigate("/admin/default");
      window.location.reload();
    } catch (error) {
      toast.error(error.response?.data?.error || "Login failed");
    }
  };

  return (
    <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Sign In
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your email and password to sign in!
        </p>

        {/* Email */}
        <InputField
          variant="auth"
          label="Email*"
          placeholder="Enter email"
          id="email"
          type="text"
          value={email}
          onChangeFun={(e) => {
            setEmail(e.target.value);
            setError({ ...error, email: "" });
          }}
          state={error?.email ? "error" : ""}
        />
        {error.email && (
          <p className="mb-2 ml-2 text-sm text-red-500">{error.email}</p>
        )}

        {/* Password */}
        <InputField
          variant="auth"
          extra="mt-4"
          label="Password*"
          placeholder="Enter Password"
          id="password"
          type="password"
          state={error?.password ? "error" : ""}
          value={password}
          onChangeFun={(e) => {
            setPassword(e.target.value);
            setError({ ...error, password: "" });
          }}
        />
        {error.password && (
          <p className="mb-2 ml-2 text-sm text-red-500">{error.password}</p>
        )}

        <button
          onClick={handleLogin}
          className="linear mt-4 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
        >
          Sign In
        </button>
      </div>
    </div>
  );
}
